"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPickupPointsMaxFee = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
const getPickupPointsMaxFee = (deliveryMethods)=>{
    const pickupPointsMaxFees = deliveryMethods.filter((deliveryMethod)=>deliveryMethod.type !== _globalApiClientReact.GlobalShoppingDeliveryMethodDtoType.Home).map((pickupPoint)=>pickupPoint.maxFee).filter((fee)=>fee != null);
    return pickupPointsMaxFees.length !== 0 ? Math.max(...pickupPointsMaxFees) : undefined;
};
exports.getPickupPointsMaxFee = getPickupPointsMaxFee;
